import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {DigitalInDescription} from "./digitalInDescription";
import {UrlBuilder} from "../url-builder/url.builder";

@Injectable({
  providedIn: 'root'
})
export class DigitalInDescriptionDataservice {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<DigitalInDescription> {
    this.uiUrl = this.url.GetDigitalInDescriptionUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<DigitalInDescription>(this.uiUrl);
  }



}

